import * as React from 'react';
import TableFilesPayRollIncident from './TableFilesPayRollIncident';
import EstatusLine from './EstatusLine';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import moment from "moment";
import { formatterMxn } from "../../../helpers/formatoMoneda";
  
  function Row(props: { row :any}) {
    const { row } = props;
    const [openDate, setOpenDate] = React.useState(false);  
    const [openFile, setOpenFile] = React.useState(false);  

    return (
      <>
           <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> Sede</span> </TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.Sede}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'>{`Área o proyecto`}</span></TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.AreaProyecto}</span></TableCell> 
              </TableRow>             
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Categoría`}</span></TableCell>
                <TableCell align="right">
                  {/* <span className='infoPayRollIncident' >{row.TipoConcepto}</span> */}
                  <FormControl>
                     <RadioGroup
                        row
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                     
                        //value={row.TipoConcepto}
                        //onChange={handleChange}
                      >
                        <FormControlLabel value="Percepcion" control={<Radio     style={{
                          color: "#FABB00",
                        }}/>} label="Percepción" />
                        <FormControlLabel value="Deduccion" control={<Radio    style={{
                          color: "#FABB00",
                        }} />} label="Deducción" />
                      </RadioGroup>
                  </FormControl>
                </TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Tipo`} </span></TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.TipoCobro}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Concepto`}</span> </TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.ConceptName}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncidentEnfasis'>{`Fechas seleccionadas`}</span> </TableCell>
                <TableCell align="right">         
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpenDate(!openDate)}
                    >
                    {openDate ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>            
                </TableCell>
                </TableRow>
                <TableRow >
                 <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2} >
                    <Collapse in={openDate} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                      {`${moment(row.FechaGenerado).utc().format('DD/MM/yyyy')} - ${moment(row.FechaFin).utc().format('DD/MM/yyyy')}`}
                    </Box>
                    </Collapse>
                 </TableCell>
              </TableRow>             
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Cantidad`}</span> </TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.Total ===0 ? '$0.00': formatterMxn(row.Total)}</span></TableCell> 
              </TableRow>  
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Unidad`}</span> </TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.Tipo}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncidentEnfasis'> {`Archivos Adjuntos`} </span></TableCell>
                <TableCell align="right">         
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpenFile(!openFile)}
                    >
                    {openFile ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>            
                </TableCell>
              </TableRow> 
              <TableRow>
                 <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2} >
                    <Collapse in={openFile} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                       <TableFilesPayRollIncident idPayrollIncident={row.id}/>
                    </Box>
                    </Collapse>
                 </TableCell>
              </TableRow>   
              <TableRow >  
                <TableCell colSpan={2} component="th" scope="row">
                    <div className='titlePayRollIncidentEnfasis'> {`Comentarios`} </div>
                    <div className='containerTextAreaPayRollInput'> 
                    <TextField
                      id="outlined-multiline-static"   
                      fullWidth                  
                      multiline
                      rows={3}
                      disabled
                      defaultValue={row.Comentarios}
                      variant="standard"
                      InputProps={{                        
                        disableUnderline: true,
                      }}
                    />

                    </div>
               </TableCell>                             
              </TableRow>    
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Estatus`}</span></TableCell>               
                <TableCell align="right"><EstatusLine row={row}></EstatusLine></TableCell>
             </TableRow>           
        
      </>
    );
  }  

const TableEditPayRollIncident = ({row}:any) => {


     return (
        <TableContainer >
          <Table aria-label="collapsible table">
           <TableBody>
                <Row key={row.id} row={row} />           
            </TableBody>
          </Table>
        </TableContainer>
      );
}

export default TableEditPayRollIncident